// SmartLink.tsx
import React, { useCallback } from "react";
import { useNavigate, useHref, To } from "react-router-dom";

function isModifiedEvent(e: React.MouseEvent<HTMLAnchorElement>) {
    return e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0;
}
function isExternalHref(href: string | undefined) {
    if (!href) return false;
    return /^(?:[a-z][a-z0-9+.-]*:)?\/\//i.test(href)   // http://, https://, //, mailto:, tel:, etc.
        || href.startsWith("mailto:") || href.startsWith("tel:");
}

type SmartLinkProps = Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, "href" | "onClick"> & {
    to: To;
    userId: string;
    replace?: boolean;
    state?: any;
    external?: boolean; // force external behavior if needed
    onClick?: React.MouseEventHandler<HTMLAnchorElement>;
    disabled?: boolean;
};

export default function Link({
                                      to,
                                      userId,
                                      replace,
                                      state,
                                      external,
                                      onClick,
                                      target,
                                      disabled,
                                      ...rest
                                  }: SmartLinkProps) {
    const navigate = useNavigate();
    const href = useHref(to);

    const handleClick = useCallback(
        (e: React.MouseEvent<HTMLAnchorElement>) => {
            onClick?.(e);
            if (e.defaultPrevented) return;           // user handler took over
            if (disabled) { e.preventDefault(); return; }
            if (target === "_blank" || isModifiedEvent(e)) return;   // let browser handle
            if (external || isExternalHref(href)) return;            // real external link

            // Set the userId in localStorage when the link is clicked
            localStorage.setItem("userId", userId.toString());

            e.preventDefault();                                     // SPA nav
            navigate(to, { replace, state });
        },
        [onClick, disabled, target, external, href, navigate, to, replace, state, userId]
    );

    return <a href={href} onClick={handleClick} {...rest} />;
}